import { AgencySettingsResponseTypes } from "backend";
import { Requests } from "../common/request.common";
import { get, post, postEmpty } from "./common";

export const agencySettings = {
    obtain() {
        return get<AgencySettingsResponseTypes.Obtain>("/agency-settings/obtain");
    },
    update(data: typeof Requests.AgencySettings.Update.Input) {
        return post<typeof data>("/agency-settings/update", data);
    },
    attendanceLocations() {
        return get<AgencySettingsResponseTypes.AttendanceLocations>(
            "/agency-settings/attendance-location/record",
        );
    },
    createAttendanceLocation(data: typeof Requests.AgencySettings.CreateAttendanceLocation.Input) {
        return post<typeof data, AgencySettingsResponseTypes.CreateAttendanceLocation>(
            `/agency-settings/attendance-location/create`,
            data,
        );
    },
    updateAttendanceLocation(
        id: string,
        data: typeof Requests.AgencySettings.UpdateAttendanceLocation.Input,
    ) {
        return post<typeof data>(`/agency-settings/attendance-location/update/${id}`, data);
    },
    deleteAttendanceLocation(id: string) {
        return postEmpty(`/agency-settings/attendance-location/delete/${id}`);
    },
    obtainAttendanceLocation(id: string) {
        return get<AgencySettingsResponseTypes.ObtainAttendanceLocation>(
            `/agency-settings/attendance-location/obtain/${id}`,
        );
    },
    optionAttendanceLocations: async () => {
        return (
            (await get<AgencySettingsResponseTypes.OptionAttendanceLocations>(
                "/agency-settings/option/attendance-locations",
            ).execute()) ?? []
        );
    },
};
